import { memo } from "react";
import { ExclamationCircleOutlined, InfoCircleOutlined, LineChartOutlined, WarningOutlined } from "@ant-design/icons";
import { Card, Col, Row } from "antd";
import Text from "antd/es/typography/Text";
import { formatTrackerCurrency } from "../../pages/MilestoneInvoiceTracker/tracker.utils";
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';


function SummaryCardsComponent({
  totalMilestoneCount,
  totalMilestoneAmount,
  approvedCount,
  approvedAmount,
  pendingInvoiceCount,
  pendingInvoiceAmount,
  invoiceMismatch,
  isPendingInvoiceFilterActive,
  onPendingInvoiceClick,
}){

  return(

    <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
      <Col xs={24} sm={12} lg={6}>
        <Card
          style={{
            borderRadius: 12,
            border: "none",
            background: "#fafafa",
            boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
            padding: 0,
            overflow: "hidden",
          }}
          styles={{ body: { padding: "16px" } }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div style={{ flex: 1 }}>
              <Text style={{ fontSize: 12, fontWeight: 600, color: "rgb(102, 112, 133)", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                Total Milestones
              </Text>
              <div style={{ marginTop: 8 }}>
                <Text style={{ fontSize: 20, fontWeight: 700, color: "#262626" }}>
                  {totalMilestoneCount}
                </Text>
              </div>
              <Text style={{ fontSize: 11, color: "#8c8c8c", marginTop: 8, display: "block" }}>
                TCV: {formatTrackerCurrency(totalMilestoneAmount)}
              </Text>
            </div>
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: "12px",
                background: "rgb(230, 244, 255)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18,
                fontWeight: 700,
                flexShrink: 0,
                boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
              }}
            >
            <LineChartOutlined style={{ fontSize: 20, color: "rgb(22, 119, 255)", marginTop: 2 }} />
            </div>
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} lg={6}>
        <Card
          style={{
            borderRadius: 12,
            border: "none",
            boxShadow: "0 1px 4px rgba(22,119,255,0.15)",
            padding: 0,
            overflow: "hidden",
          }}
          styles={{ body: { padding: "16px" } }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div style={{ flex: 1 }}>
              <Text style={{ fontSize: 12, fontWeight: 600, color: "rgb(102, 112, 133)", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                Invoice Submitted
              </Text>
              <div style={{ marginTop: 8 }}>
                <Text style={{ fontSize: 20, fontWeight: 700, color: "#262626" }}>
                  {formatTrackerCurrency(approvedAmount)}
                </Text>
              </div>
              <Text style={{ fontSize: 11, color: "#8c8c8c", marginTop: 8, display: "block" }}>
                Submitted Count: {approvedCount}
              </Text>
            </div>
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: "12px",
                background: "rgb(246, 255, 237)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18,
                fontWeight: 700,
                flexShrink: 0,
                boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
              }}
            >
              {<ThumbUpOutlinedIcon style={{ fontSize:20,color: "rgb(82, 196, 26)",marginTop: 2 }} />}
            </div>

          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} lg={6}>
        <Card
          hoverable={Boolean(onPendingInvoiceClick)}
          onClick={() => onPendingInvoiceClick?.()}
          style={{
            borderRadius: 12,
            border: isPendingInvoiceFilterActive ? "2px solid #f09b41ff" : "none",
            boxShadow: isPendingInvoiceFilterActive
              ? "0 0 0 2px rgba(250,140,22,0.18), 0 3px 8px rgba(250,140,22,0.25)"
              : "0 1px 4px rgba(250,140,22,0.15)",
            padding: 0,
            overflow: "hidden",
            cursor: onPendingInvoiceClick ? "pointer" : undefined,
          }}
          styles={{ body: { padding: "16px" } }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div style={{ flex: 1 }}>
              <Text style={{ fontSize: 12, fontWeight: 600, color: "rgb(102, 112, 133)", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                Pending Invoice
              </Text>
              <div style={{ marginTop: 8 }}>
                <Text style={{ fontSize: 20, fontWeight: 700, color: "#262626" }}>
                  {formatTrackerCurrency(pendingInvoiceAmount)}
                </Text>
              </div>
              <Text style={{ fontSize: 11, color: "#8c8c8c", marginTop: 8, display: "block" }}>
                Pending Invoice Count: {pendingInvoiceCount}
              </Text>
            </div>
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: "12px",
                background: "rgb(255, 251, 230)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18,
                fontWeight: 700,
                flexShrink: 0,
                boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
              }}
            >
              <ExclamationCircleOutlined style={{ fontSize: 20, color: "rgb(250, 187, 2)", marginTop: 2 }} />
            </div>
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12} lg={6}>
        <Card
          style={{
            borderRadius: 12,
            border: "none",
            boxShadow: "0 1px 4px rgba(255,77,79,0.15)",
            padding: 0,
            overflow: "hidden",
            minHeight: "118px"
          }}
          styles={{ body: { padding: "16px" } }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div style={{ flex: 1 }}>
              <Text style={{ fontSize: 12, fontWeight: 600, color: "rgb(102, 112, 133)", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                Invoice Mismatch
              </Text>
              <div style={{ marginTop: 8 }}>
                <Text style={{ fontSize: 20, fontWeight: 700, color: "#262626" }}>
                  {formatTrackerCurrency(invoiceMismatch ?? 0)}
                </Text>
              </div>
            </div>
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: "12px",
                background: "#fff1f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18,
                fontWeight: 700,
                flexShrink: 0,
                boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
              }}
            >
              <WarningOutlined style={{ fontSize: 20, color: "#ec3828ff", marginTop: 2 }} />
            </div>

          </div>
        </Card>
      </Col>
    </Row>

  )
}

export const SummaryCards = memo(SummaryCardsComponent);